import { EpimsBaseEntityDto } from './epim-base.dto';
export class GroundRentPaymentMasterDto extends EpimsBaseEntityDto {

   OwnerType: string;
   ObligationPeriod: string;
   TotalAcreage: number
   Unit: string;
   TotalAmount: number
   Description: string;
   CreatedBy: string;
   LandCode: string;
   SubscriptionUserId: string;
   Status: string;
   LandTitleId: string;
   ReminderDays: string;
   ReminderEmail: string;
   Remarks: string;
   Years: string;
   Days: string;
   Rate: string;
   TerrainId: string;
   ApprovalStatus: string;
   LessorsId: string;
   Currency: string;
   LessorInfo_LesssorId: string;
   ReminderPhone: string;
   LastCallDate: Date;
   NextCallDate: Date;
   EndCallDate: Date;
   FirstCallDate: Date;
   DateCreated: Date;
   FacilityID: string;
   FacilityName: string;
   CompanyRate: string;
   GovtRate: string;
   AgreedRate: string;
   BulkPaymentTrackId: string;
   ApprovedBy: string;
   DateApproved: Date;
   ApprovalComment: string;
   PaidBy: string;
   PaidDate: Date;
   PaymentComment: string;
   PaymentStatus: string;
   BulkPaymentHistoryId: string;
   AddressBookId: string;


}
